// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { LetterDetails } from "@insite/content-library/Widgets/Brand/AlphabetNavigation";
import AlphabetNavigation, { AlphabetNavigationStyles } from "@sc/Overrides/Widgets/Brand/AlphabetNavigation";
import React, { FC, useState } from "react";

interface Props {
    letterDetails: LetterDetails[];
    extendedStyles?: BrandAlphabetNavigationStyles;
    onBrandLetterClick?: (letter: string) => void;
    // XNG-Changes
    handleSearchFilterBrands?: (e: string) => void;
    searchFilterBrands?: string;
    lastLetterClicked?: string;
}

export interface BrandAlphabetNavigationStyles {
    alphabetNavigation?: AlphabetNavigationStyles;
}

export const brandAlphabetNavigationStyles: BrandAlphabetNavigationStyles = {};

const BrandAlphabetNavigation: FC<Props> = ({
    letterDetails,
    onBrandLetterClick,
    extendedStyles,
    // XNG-Changes
    handleSearchFilterBrands,
    searchFilterBrands,
    lastLetterClicked,
}) => {
    const [styles] = useState(() => mergeToNew(brandAlphabetNavigationStyles, extendedStyles));

    return (
        <AlphabetNavigation
            alphabet={letterDetails}
            extendedStyles={styles.alphabetNavigation}
            onLetterClick={onBrandLetterClick}
            // xng-change
            handleSearchFilterBrands={handleSearchFilterBrands}
            searchFilterBrands={searchFilterBrands}
            lastLetterClicked={lastLetterClicked}
        />
    );
};

export default BrandAlphabetNavigation;
